import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardMedia, Typography, Container, CircularProgress, Alert, Button, TextField, Snackbar } from '@mui/material';
import { CartContext } from '../context/CartContext';

function ProductDetail() {
  const { id } = useParams();
  const { addToCart } = useContext(CartContext);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    fetch(`/api/products/${id}`)  // Fixed: changed backtick to parenthesis
        .then(res => {
          if (!res.ok) {
            throw new Error('Network response was not ok');
          }
          return res.json();
        })
        .then(data => {
          setProduct(data);
          setLoading(false);
        })
        .catch(err => {
          setError(err.message);
          setLoading(false);
        });
  }, [id]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">Error fetching product: {error}</Alert>;
  }

  if (!product) {
    return <Alert severity="warning">Product not found.</Alert>;
  }

  const handleAddToCart = () => {
    for (let i = 0; i < quantity; i++) {
      addToCart(product);
    }
    setSnackbarOpen(true);
  };

  return (
      <Container>
        <Card>
          <CardMedia
              component="img"
              height="300"
              image={product.itemData.imageUrl}
              alt={product.itemData.name}
          />
          <CardContent>
            <Typography gutterBottom variant="h4" component="div">
              {product.itemData.name}
            </Typography>
            <Typography variant="h5" color="text.secondary">
              {new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: product.itemData.variations[0].itemVariationData.priceMoney.currency
              }).format(product.itemData.variations[0].itemVariationData.priceMoney.amount / 100)}
            </Typography>
            <Typography variant="body1" paragraph>
              {product.itemData.description}
            </Typography>
            <TextField
                label="Quantity"
                type="number"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                inputProps={{ min: 1 }}
                sx={{ mb: 2, mr: 2 }}
            />
            <Button onClick={handleAddToCart} variant="contained" color="primary">
              Add to Cart
            </Button>
          </CardContent>
        </Card>
        <Snackbar
            open={snackbarOpen}
            autoHideDuration={3000}
            onClose={() => setSnackbarOpen(false)}
            message="Item added to cart"
        />
      </Container>
  );
}

export default ProductDetail;